import React, { memo } from "react";
import { useSelector } from "react-redux";
import { Stack, Button, Icon } from "investira.react.components";
import { PageTemplate } from "../../components/templates";
import { DialogAddRecursoGarantidor } from "../../components/organisms";
import { useRecursoGarantidorContext } from "../../contexts/RecursoGarantidorContext";
import RecursoGarantidorDataGrid from "./RecursoGarantidorDataGrid";

const RecursoGarantidor = memo(() => {
  const { actions } = useRecursoGarantidorContext();

  const xDefaultEntidadeStored = useSelector((store) => store.entidade.current);

  return (
    <PageTemplate
      title="Recurso Garantidor"
      subtitle={xDefaultEntidadeStored.entidade}
      maxWidth="lg"
      headerRenderActions={
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="insert" size={16} />}
            size="small"
            sx={{ px: 2 }}
            onClick={() => actions.handleDialogChanged("add")}
          >
            Novo Recurso
          </Button>
        </Stack>
      }
    >
      <RecursoGarantidorDataGrid />
      <DialogAddRecursoGarantidor />
    </PageTemplate>
  );
});

export default RecursoGarantidor;
